const error = `
  error {
    type
    code
    desc
    message
    status
		reason
		reason_code
  }
`

const airline = `
  airline {
    code
    name
    smallImage
  }
`

const airport = `
  airport {
    code
    name
    city
    state
    country
    latitude
    longitude
    isoCountryCode
    gmtTimeZoneOffset
    location
    cityId
  }
`

const equipment = `
  equipment {
    code
    name
    type
  }
`
const displayAirline = `
  displayAirline {
    name
    code
    smallImage
    shortName
  }
`

const sliceDisplayText = `
  displayText {
    stopsText
    cabinClassDisclosureText
    departureOpenJaw
    arrivalOpenJaw
  }
`

const segmentDisplayText = `
  displayText {
    flightNumber
    displayCabinName
    equipmentText
    planeChangeText
    differentAirportText
    operatedByText
    layoverText
  }
`

const transitAirport = `
  airport {
    code
    name
    city
    isoCountryCode
    displayLocation
  }
`
const transitTime = `
  time {
    dateTime
    displayTime
    displayDate
  }
`

const price = `
  price {
    type
    currencyCode
    currencySymbol
    amount
    dollar
    cents
    creditSummary {
      creditAvailable
      creditApplied
      forfeitAmount
      changeFee
    }
  }
`

const airPriceCovidAttributes = `
  covidAttributes {
    airlineCode
    airlineLogo
    airlineName
    covidAttrs {
      noChangeFees
      mandatoryMask
      healthCert
      tempChecks
      extraCleaning
      middleSeatBlocked
      reducedOnboard
    }
  }
`

const airPriceGuidance = `
  priceGuidance {
    high
    low
    isEligible
  }
`

const airPriceSegments = `
  segments {
    id
    cabinName
    cabinClass
    flightNumber
    equipment
    stopQuantity
    duration: formattedDuration
    isOvernight
    flightNumber
    equipment
    marketingAirline
    operatingAirline
    isSubjectToGovtApproval
    seatsAvailable
    ${displayAirline}
    departInfo {
      isAltAirport
      ${transitAirport}
      ${transitTime}
    }
    arrivalInfo {
      isAltAirport
      ${transitAirport}
      ${transitTime}
    }
    ${segmentDisplayText}
  }
`
export const baggage = `
  baggage {
    disclaimer
    data {
      sliceId
      airlineCode
      airlineName
      airlineLogo
      baggageInfoUrl
      baggageOptions {
        type
        bags {
          id
          name
          availability
          cost
          currencyCode
          weight
          dimensions
        }
      }
    }
  }
`

const airPriceSlices = `
  slices {
    id
    stops
    isOvernight
    overnightDays
    willArriveOnDiffDate
    voidWindowInfo {
      timeStamp
      tzDesignator
      cancelTimeZone
      clientUTCDateTime
      hoursLeft
      minutesLeft
    }
    ${displayAirline}
    ${sliceDisplayText}
    duration
    durationInSeconds
    departInfo {
      ${transitAirport}
      ${transitTime}
    }
    arrivalInfo {
      ${transitAirport}
      ${transitTime}
    }
    ${airPriceSegments}
  }
`

export const voidWindowInfo = `
  voidWindowInfo {
    timeStamp
    hoursLeft
  }
`

const fareBrandSlicesQuery = `
  slices {
  segment {
    arrivalDateTime
    bkgClass
    cabinClass
    cabinName
    departDateTime
    destAirport
    duration
    equipmentCode
    flightNumber
    genericSeatAssgnFlag
    id
    segmentId
    marketingAirline
    origAirport
    overnightFlight
    premiumSeatingFlag
    seatmapAvailable
    seatSelectionAllowed
    allowStandby
    allowCabinUpgrades
    allowPreferredSeating
    allowPriorityBoarding
    stopQuantity
    distance
  }
  brandAttributeMatrix
  fareBrands {
    defaultBrand
    bookingClasses
    groupId
    refId
    contentSourceId
    name
    displayName
    fareInfoList {
      fareBasisCode
    }
    ancillaries {
      tag
      name
      offerType
      coreAttribute
      displayOrderingVal
      setiDisplayOrderingVal
    }
    coreFBAncillaries {
      color
      icon
      name
      modifier
      index
    }
    description
    key
    brandTier
    airline
    fareDifference
    isFareDifferenceNegative
    isSelected
    itineraryType
    totalFare
    splitTicketFees
    sliceIds
    totalUpsellDisplayPrice {
      amount
      currency
    }
    totalFare
    fees {
      amount
      currency
    }
    tax {
      amount
      currency
    }
    fare {
      amount
      currency
    }
    pricing {
      amount
      ctaText
      text
      amountInFloat
    }
    enrichedContent {
      image
      content {
          title
          description
      }
    }
  }
  duration
  id
  airlineName
  airlineLogo
  origAirportCode
  destAirportCode
  sliceId
  willRenderContent
  selectedBrandIndex
}
`

export const fareBrands = `
fareBrandsInfo {
  defaultBrandsBySliceId {
    id
    value
  }
  keysBySliceId {
    id
    value
  }
  initialSelections {
    id
    value
  }
  fareBrandsByKey {
    defaultBrand
    bookingClasses
    groupId
    refId
    contentSourceId
    name
    displayName
    description
    key
    brandTier
    airline
    fareDifference
    isFareDifferenceNegative
    isSelected
    itineraryType
    totalFare
    splitTicketFees
    fareInfoList {
      fareBasisCode
    }
    ancillaries {
      name
      offerType
      coreAttribute
      displayOrderingVal
      tag
      setiDisplayOrderingVal
    }
    coreFBAncillaries {
      color
      icon
      name
      modifier
      index
    }
    sliceIds
    totalUpsellDisplayPrice {
      amount
      currency
    }
    fees {
      amount
      currency
    }
    tax {
      amount
      currency
    }
    fare {
      amount
      currency
    }
    pricing {
      amount
      text
      ctaText
      amountInFloat
    }
  }
  upsellOptions {
    groupId
    refId
    token
    itemDetailsKey
    cartToken
    priceKey
    fareFamilyReference
    isPaidBaggageEligible
    isSeatEligible
    ${baggage}
    slices {
      id
      ${sliceDisplayText}
      segments {
        id
        cabinName
        cabinClass
        displayText {
          displayCabinName
        }
      }
    }
    ${price}
    savings {
      totalStrikeThroughPrice
      totalSavings
      perPersonSavings
      perPersonStrikeThroughPrice
      savingsPercentage
    }
    totalPackagePrice {
      currency
      amount
    }
    totalUpsellDisplayPrice {
      currency
      amount
    }
    totalCostWithHotelMandatoryFees {
      currency
      amount
    }
    fees {
      amount
      currency
    }
    tax {
      amount
      currency
    }
    fare {
      amount
      currency
    }
    totalPayLater {
      currency
      amount
    }
    totalHotelMandatoryFees {
      currency
      amount
    }
    roomMandatoryFees {
      currency
      amount
    }
  }
  hasOneSliceOnly
  firstSliceIdWithContent
  ${fareBrandSlicesQuery}
}
`

export const airPassengers = `
  passengers {
    ADULT
    CHILD
    INFANT
    LAP_INFANT
    MILITARY
    SEAT_INFANT
    SENIOR_CITIZEN
  }
`

export const airDetailsFireFlyQuery = `
  query airPriceResponse($input: AirPriceRequest) {
    airPriceResponse(input: $input) {
      # rawResponse
      isFireFly
      itemKey
      priceKey
      isFused
      isBEC
      isPaidBaggageEligible
      isSeatEligible
      ${baggage}
      ${error}
      ${airline}
      ${airport}
      ${equipment}
      ${airPriceSlices}
      ${airPriceCovidAttributes}
      ${airPriceGuidance}
      ${price}
      ${voidWindowInfo}
      ${airPassengers}
    }
  }
`

export const airPriceFireFlyQuery = `
  query airPriceResponse($input: AirPriceRequest) {
    airPriceResponse(input: $input) {
      # rawResponse
      isFireFly
      itemKey
      priceKey
      isFused
      isBEC
      isSeatEligible
      isPaidBaggageEligible
      ${baggage}
      ${error}
      ${airline}
      ${airport}
      ${equipment}
      ${airPriceSlices}
      ${airPriceCovidAttributes}
      ${airPriceGuidance}
      ${price}
      ${voidWindowInfo}
      ${fareBrands}
      ${airPassengers}
    }
  }
`

export const airPriceFireFlyQueryFareBrandsOnly = `
  query airPriceResponse($input: AirPriceRequest) {
    airPriceResponse(input: $input) {
      # rawResponse
      ${error}
      fareBrandsInfo {
        slices {
          fareBrands {
            defaultBrand
            name
            ancillaries {
              tag
              name
              offerType
            }
            key
            isSelected
            totalFare
            pricing {
              amount
              ctaText
              text
              amountInFloat
            }
          }
        }
      }
    }
  }
`
